import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'

export default class extends Controller {
  static targets = ['number', 'name', 'expiryDate', 'cvc']

  connect() {
    this.numberMask = IMask(this.numberTarget, {
      mask: '0000 0000 0000 0000',
    })

    this.nameMask = IMask(this.nameTarget, {
      mask: /^.+$/,
      prepare: (value) => value.toUpperCase(),
    })

    this.expiryDateMask = IMask(this.expiryDateTarget, {
      mask: 'MM/YY',
      blocks: {
        MM: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
        },
        YY: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 99,
        },
      },
    })

    this.cvcMask = IMask(this.cvcTarget, {
      mask: '000',
      placeholder: 'CVC',
    })
  }

  disconnect() {
    this.numberMask.destroy()
    this.nameMask.destroy()
    this.expiryDateMask.destroy()
    this.cvcMask.destroy()
  }
}
